import 'draft-js/dist/Draft.css';

import { Button, Col, Divider, Row, Select } from 'antd';
import React, { useCallback } from 'react';

import FullPageLoader from '../../../foundation/components/full_page_loader/FullPageLoader';
import Modal from '../../../foundation/components/modal/Modal';
import { Variant } from '../redux/types';
import { useVariantCreateMetadataModalLogic } from './hooks';

type VariantCreateMetadataModalType = {
  closeModal: () => void;
  variantMetaData?: Variant | null;
  handleVariantCreate?: (variant_type: string) => Promise<{
    variant_id: number;
    created: boolean;
    message: string;
  }>;
};

const VariantCreateMetadataModal = ({
  closeModal,
  variantMetaData,
  handleVariantCreate,
}: VariantCreateMetadataModalType) => {
  // All logic extracted to custom hook for separation of concerns
  const {
    isLoading,
    variantKeyValues,
    createModalOpts,
    handleSaveChanges,
    variantTypeOptions,
    selectedVariantType,
    setSelectedVariantType,
  } = useVariantCreateMetadataModalLogic({
    closeModal,
    variantMetaData,
    handleVariantCreate,
  });

  // Build modal title JSX here since hooks can't return JSX
  const modalOpts = createModalOpts(
    <span className="h-variant-link-modal__modal-title">{`Variant metadata:`}</span>,
  );

  const variantValueRenderer = useCallback((label: string, value?: string) => {
    const shouldHighlight = false;

    return (
      <>
        <Row>
          <Col flex={'35%'} className="variant-summary__field-label">
            {label}
          </Col>
          <Col
            flex={'65%'}
            className="variant-summary__field-value"
            style={{
              color: shouldHighlight ? '#FFA244' : 'black',
            }}
          >
            {value}
          </Col>
        </Row>
        <Divider style={{ margin: '5px 0px' }} />
      </>
    );
  }, []);

  const renderVariantInformation = useCallback(() => {
    return variantKeyValues.map((item) => {
      if (item.label === 'Variant type') {
        return (
          <>
            <Row>
              <Col flex={'35%'} className="variant-summary__field-label">
                {item.label}
              </Col>
              <Col flex={'65%'} className="variant-summary__field-value">
                <Select
                  options={variantTypeOptions}
                  value={selectedVariantType}
                  onChange={(v: string) => setSelectedVariantType(v)}
                  showSearch
                  style={{ width: '100%' }}
                />
              </Col>
            </Row>
            <Divider style={{ margin: '5px 0px' }} />
          </>
        );
      }
      return variantValueRenderer(item.label, item.value);
    });
  }, [
    variantKeyValues,
    variantTypeOptions,
    selectedVariantType,
    setSelectedVariantType,
  ]);

  return (
    <Modal {...modalOpts} className="h-variant-link-modal">
      {isLoading && <FullPageLoader />}

      <div className="h-variant-link-modal__content-wrapper">
        <div className="h-variant-link-modal__info-wrapper">
          {renderVariantInformation()}
        </div>
      </div>
      <div className="h-variant-link-modal__save-changes-btn-wrapper">
        <Button
          type="primary"
          onClick={handleSaveChanges}
          className="h-variant-link-modal__save-changes-btn"
          disabled={!selectedVariantType || isLoading}
        >
          Save variant
        </Button>
      </div>
    </Modal>
  );
};

export default VariantCreateMetadataModal;
